import { render, staticRenderFns } from "./RailsSectionResume.vue?vue&type=template&id=bd2a8618&scoped=true&"
import script from "./RailsSectionResume.vue?vue&type=script&lang=js&"
export * from "./RailsSectionResume.vue?vue&type=script&lang=js&"
import style0 from "./RailsSectionResume.vue?vue&type=style&index=0&id=bd2a8618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2a8618",
  null
  
)

/* custom blocks */
import block0 from "./RailsSectionResume.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports